import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, DataTables, BreadCumb, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';

let apiClient = ApiClient.getInstance();
//Header 
const headersDataTable = [
    { title: "Nombre", value: true },
    { title: "Código", value: true },
    { title: "Stock", value: true },
];

class InventoryDataView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            total: 0,
            ListItemsGroup: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }
    }

    componentDidMount = async () => {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liInvetario");
        //await this.callDocumentsListService();
        let listGroupItemCodeResult = await apiClient.getGroupsItemData();
        this.setState({
            ListItemsGroup: listGroupItemCodeResult.data.GrupoArticulo
        })
    }
    //Buscar inventarios
    searchItems = async filter => {
        await this.callDocumentsListService(filter);
    };
    //Listar Documentos por Filtros
    callDocumentsListService = async (filter = { priceValue: '---', groupCodeValue: '---' }) => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        let inventoryDataResponse = await apiClient.getItemsrList(filter);
        enableSpinner(false);
        if (inventoryDataResponse.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                data: inventoryDataResponse.data.partners,
                total: inventoryDataResponse.data.totalRows
            });
        }
    };


    render() {
        const { headers, data, updateData, total, ListItemsGroup, _user } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'DATOS DE ARTÍCULO'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>

                    <h2 className="md-display-1">
                        <label id="liInvetario" className="text-muted">
                            &nbsp;DATOS DE ARTÍCULO
                        </label>
                    </h2>
                    <DataTables
                        headers={headers}
                        view={"inventoryData"}
                        data={data}
                        search={this.searchItems}
                        totalRows={total}
                        ListItemsGroup={ListItemsGroup}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InventoryDataView);
